import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { IUserNetwork } from "types/api/addonsApiInterface";
import { IOsDetails, IServerTypes } from "types/api/serversApiInterface";

import MailboxProBox from "../MailboxProBox";
import NfsBox from "../NfsBox";
import ServerOsBox from "../ServerOsBox";
import ServerTypeBox from "../ServerTypeBox";

const TypeAndOs = ({
 description,
 osList,
 networkList,
 serverType,
 os,
 mailboxProNumber,
 network,
 setData
}: {
 description: string;
 osList: Array<IOsDetails>;
 networkList: Array<IUserNetwork>;
 serverType: string;
 os: number;
 mailboxProNumber: number;
 network: number;
 setData: (section: string, value: string | number | boolean | IServerTypes) => void;
}): ReactElement => {
 const handleSetServer = (type: string) => {
  setData("serverType", type);
  if (type !== "custom") {
   setData("os", 6);
   setData("osName", "debian-12");
  }
 };

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="server.add.selectServerType" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id={description} />
    </Typography>
    <Stack>
     <Typography variant="unboundedTitle" sx={{ fontSize: 16 }}>
      Custom
     </Typography>
     <ServerOsBox
      selectedOs={os}
      osList={osList}
      selectOs={(value) => {
       setData("os", value?.id || 0);
       setData("osName", value?.name || "");
       setData("serverType", "custom");
      }}
     />
    </Stack>
    <Stack>
     <Typography variant="unboundedTitle" sx={{ fontSize: 16 }}>
      Management
     </Typography>
     <ServerTypeBox
      provider="htz"
      selectedType={serverType}
      selectType={(type) => handleSetServer(type || "")}
     />
    </Stack>
    {serverType === "container-mail-pro" && (
     <Stack>
      <Typography variant="unboundedTitle" sx={{ fontSize: 16 }}>
       PRO config
      </Typography>
      <MailboxProBox
       selectedNumber={mailboxProNumber}
       selectNumber={(value) => setData("mailboxPro", value)}
      />
     </Stack>
    )}
    {serverType === "nfs-server" && (
     <Stack>
      <Typography variant="unboundedTitle" sx={{ fontSize: 16 }}>
       NFS config
      </Typography>
      <NfsBox
       networks={networkList}
       selectedNetwork={network}
       selectNetwork={(value) => setData("nfsNetwork", value)}
      />
     </Stack>
    )}
   </Stack>
  </Paper>
 );
};

export default TypeAndOs;
